export default __webpack_public_path__ + "static/media/badge_shadow.b61f19a1.png";